import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";

interface props {
  data:any
  setOpenJsonDialog: React.Dispatch<React.SetStateAction<boolean>>
  className?: string;
  // setOpen:React.Dispatch<React.SetStateAction<boolean>>;
  // getMemberList:any;
}

// const SampleRejectRsnDialog = () => {
const EvalJsonDialog = (props: props) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const [formattedJson, setFormattedJson] = useState("")

  // JSON 객체를 HTML 형식으로 포맷하는 함수
  const formatJson = (obj:any) => {
    if (!obj || typeof obj !== 'object') return '';

  // 우선순위 key 목록
  const priorityKeys = [
    "task",
    "version",
    "document_id",
    "source_id",
    "question",
    "options",
    "answer",
    "answer_index",
    "reason_path"
  ];

  // 1. 우선순위 key만 추출 (존재하는 것만)
  const prioritizedPart = priorityKeys
    .filter((key) => key in obj)
    .reduce((acc: any, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

  // 2. 나머지 key들은 기존 순서 유지
  const remainingPart = Object.keys(obj)
    .filter((key) => !priorityKeys.includes(key))
    .reduce((acc: any, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

  // 3. 두 부분을 합쳐서 최종 정렬된 객체 생성
  const sortedObj = { ...prioritizedPart, ...remainingPart };

  // 4. 기존 JSON 포맷팅 로직 유지
  const jsonString = JSON.stringify(sortedObj, null, 2);
    
    // 각 줄을 처리하여 HTML 형식으로 변환
    const formattedHtml = jsonString.split('\n').map((line:any) => {
        // 4칸 공백을 &nbsp;로 변환하여 들여쓰기 유지
        const indent = line.match(/^\s*/)[0].replace(/ /g, '&nbsp;'); // 공백을 &nbsp;로 변경
        // key를 빨간색으로 변환
        const lineWithColor = line.replace(/"([^"]+)":/g, '<span style="color: #ffd415;">"$1"</span>: ');
            return `${indent}${lineWithColor}`;
        }).join('<br />'); // 줄바꿈을 <br />로 변환

    return formattedHtml;
  };

  const getJson = async (data:any) => {

    // JSON 객체를 문자열로 변환하면서 key와 value의 스타일을 다르게 설정
    const formattedJsonWithColors = formatJson(data);

    setFormattedJson(formattedJsonWithColors);

  }

  useEffect(() => {

    // console.log('props.data',props.data)
    getJson(props.data);

    const handleSelectAll = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === 'a') {
        e.preventDefault();
        const dialog = document.querySelector('.json-dialog-content');
        if (dialog) {
          const range = document.createRange();
          range.selectNodeContents(dialog);
          const sel = window.getSelection();
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      }
    };
    document.addEventListener('keydown', handleSelectAll);
    return () => document.removeEventListener('keydown', handleSelectAll);

  }, [props.data]);

  // useEffect(() => {
  //   const handleSelectAll = (e: KeyboardEvent) => {
  //     if (e.ctrlKey && e.key === 'a') {
  //       e.preventDefault();
  //       const dialog = document.querySelector('.json-dialog-content');
  //       if (dialog) {
  //         const range = document.createRange();
  //         range.selectNodeContents(dialog);
  //         const sel = window.getSelection();
  //         sel?.removeAllRanges();
  //         sel?.addRange(range);
  //       }
  //     }
  //   };
  //   document.addEventListener('keydown', handleSelectAll);
  //   return () => document.removeEventListener('keydown', handleSelectAll);
  // }, []);

  return (
    <Box >
    <Dialog maxWidth="lg" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>JSON 미리보기</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers className={props.className}>
        <Box sx={{ width: "1400px", margin: '12px auto' }}>
            <pre style={{
                backgroundColor: '#282c34', // 다크 배경
                color: '#8ae9fa',           // React 블루 계열
                padding: '20px',            // 안쪽 여백
                borderRadius: '8px',        // 모서리 둥글게
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // 그림자 효과
                fontFamily: 'Courier New, Courier, monospace', // 모노스페이스 폰트
                whiteSpace: 'pre-wrap',     // 텍스트 줄바꿈
                wordBreak: 'break-word',    // 긴 단어 줄바꿈
                overflowX: 'auto'           // 가로 스크롤 허용
            }}>
                <div dangerouslySetInnerHTML={{ __html: formattedJson }} />
            </pre>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setOpenJsonDialog(false);
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default EvalJsonDialog;
